import React, { useLayoutEffect, useRef, useState } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import Box from '@mui/material/Box';
import Map from '@common/components/CleaningMap/Map';
import Mission from '../../models/missions/mission';
import Grid from '@mui/material/Grid';
import { useMediaQuery, useTheme } from '@mui/material';
import RobotVersion from '@common/interfaces/cleaning-map/robot-version';

const MissionScaledImage: React.FC<{
  mission: Mission;
  maxHeight?: number;
}> = ({ mission, maxHeight }) => {
  const theme = useTheme();
  const matchesMdDown = useMediaQuery(() => theme.breakpoints.down('md'));

  const mapContainerRef = useRef<HTMLDivElement | null>(null);

  const [scaleFactor, setScaleFactor] = useState<number | null>(null);

  const height = (maxHeight ?? matchesMdDown) ? 264 : 412;

  useLayoutEffect(() => {
    const containerWidth = mapContainerRef.current?.clientWidth || 1;
    const containerHeight = mapContainerRef.current?.clientHeight || 1;

    const svgWidth = parseInt(theme.spacing(2), 0) + (mission.obstacleMap?.width ?? 0);
    const svgHeight = parseInt(theme.spacing(2), 0) + (mission.obstacleMap?.height ?? 0);

    const scale = Math.min(containerWidth / svgWidth, containerHeight / svgHeight);
    setScaleFactor(scale);
  }, [mission.obstacleMap?.height, mission.obstacleMap?.width, theme]);

  return (
    <Grid ref={mapContainerRef}>
      <Box
        sx={{
          height: height,
          width: '100%',
          overflow: 'hidden',
          mb: { xs: 2, md: 0 },
        }}
      >
        {scaleFactor != null && (
          <TransformWrapper limitToBounds={true} initialScale={scaleFactor} disabled>
            <TransformComponent wrapperStyle={{ width: '100%', height: '100%' }}>
              <Map
                cleaningImage={mission}
                disableAnimation
                robotVersion={
                  mission.hardwareVersion?.robotVersion != null
                    ? (mission.hardwareVersion.robotVersion as RobotVersion)
                    : RobotVersion.K900
                }
              />
            </TransformComponent>
          </TransformWrapper>
        )}
      </Box>
    </Grid>
  );
};

export default MissionScaledImage;
